import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import styled from 'styled-components'
import Icons from './Icons'

const EmptyStateContainer = styled.div`
  background-color: ${props => props.theme.palette.background.default};
  padding: ${props => props.theme.spacing(6)}px;
  font-size: 1rem;
  line-height: 1.75rem;
  color: ${props => props.theme.palette.text.secondary};
  text-align: center;
`
const EmptyStateIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${props => props.theme.spacing(12)}px;
  margin-bottom: ${props => props.theme.spacing(8)}px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 50%;
`

const EmptyStateTitle = styled(Typography)`
  font-size: 1.333rem !important;
`
const EmptyStateText = styled(Typography)`
  font-size: 0.889rem !important;
`

const EmptyState = props => {
  const { section, title, text } = props

  return (
    <EmptyStateContainer>
      <EmptyStateIcon
        style={{
          transform: 'scale(2, 2)',
        }}
      >
        <Icons
          icon={section}
          style={{
            fontSize: 24,
            marginBottom: '6px',
          }}
        />
      </EmptyStateIcon>
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateText>{text}</EmptyStateText>
    </EmptyStateContainer>
  )
}

EmptyState.propTypes = {
  section: PropTypes.string,
}

export default EmptyState
